if (typeof google !== "undefined" && google.maps) {
  const mapStyle = {
    mapTypeId: google?.maps.MapTypeId.ROADMAP,
    zoom: 15.0,
    disableDefaultUI: true,
    styles: [
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#FFFFFF" }] // Fondo blanco
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#C9E7F1" }] // Azul claro para el agua
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ color: "#E0E0E0" }] // Gris claro para carreteras principales
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#F5F5F5" }] // Calles locales en gris más claro
      }
    ]
  };

  exports.mapStyle = mapStyle;
}
